import { Component } from "react";
import * as hookActions from 'checkout/actions/hooks';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toDecimals } from "../../helpers/currency";
import { getOrderTotal } from "../../selectors/cart";

const substitutionsMap = {
  'Order Value': 'revenue',
  'Order ID': 'orderId',
  'Order Currency': 'currency',
  'Tickets Value': 'ticketsCost'
}

class CustomPixel extends Component{
  eventBindingMap = {
    'add_to_cart': () => this.props.addTicketsAddedToCartHook(this.onTicketsAdded),
    'purchase': () => this.props.addReservationCompleteHook(this.onReservationComplete)
  }

  reportEvent = (data) => {
    if (this.props.config.measurement_ids && Array.isArray(this.props.config.measurement_ids)) {
      this.props.config.measurement_ids.forEach((id) => this.props.reportEvent(this.props.type)({
        id: this.preparePixelUrl(id, data)
      }));
    }
  }

  constructor(props) {
    super(props);

    if (props.type) {
      this.eventBindingMap[props.type]?.();
    }
  }
  
  render () {
    return null;
  }

  preparePixelUrl = (url, data) => {
    let resUrl = url;
    
    Object.entries(substitutionsMap).forEach(([substitutionKey, dataKey]) => {
      if (typeof data[dataKey] !== 'undefined' && data[dataKey] !== null) {
        resUrl = resUrl.replace(`[[${substitutionKey}]]`, encodeURIComponent(data[dataKey]));
      }
    })

    return resUrl;
  }

  onReservationComplete = () => {
    const reservationSessionKey = `CustomPixel_${this.props.config.id}_onReservationComplete_${this.props.confirmationNumber}`;
    const sent = sessionStorage.getItem(reservationSessionKey);
    if (!sent) {
      const revenue = toDecimals({amount: this.props.orderTotal, currency: this.props.currency});
      const orderId = this.props.confirmationNumber;
      const currency = this.props.currency;

      this.reportEvent({ revenue, orderId, currency });

      sessionStorage.setItem(reservationSessionKey, '1');
    }
  }

  onTicketsAdded = tickets => {
    const ticketsCost = this.getTotalCostOfItems(tickets);
    const revenue = toDecimals({amount: this.props.orderTotal, currency: this.props.currency});
    const orderId = this.props.confirmationNumber;
    const currency = this.props.currency;

    this.reportEvent({ revenue, orderId, currency, ticketsCost });
  }

  getTotalCostOfItems = items => {
    let cost = 0;
    if (Array.isArray(items)) {
      items.forEach(item => {
        cost += +(item?.cost?.amount ?? 0);
        cost += +(item?.buyer_fee?.amount ?? 0);
      });
    }
    return toDecimals({ amount: cost, currency: this.props.currency });
  }
}

const mapStateToProps = state => {
    return {
        confirmationNumber: state.reservation.confirmation_number,
        orderTotal: getOrderTotal(state)?.amount ?? 0,
        currency: state.reservation.currency || 'USD',
    }
}

const mapDispatchToProps = dispatch => {
  const actions = {};
  Object.keys(hookActions).forEach(hookActionName => {
      actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomPixel)
